var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-px-md desktop-single-column full-width"},[(_vm.breadcrumbs.length)?_c('SAIBreadcrumbs',{staticClass:"print-hide q-pt-md",attrs:{"breadcrumbs":_vm.breadcrumbs}}):_vm._e(),(_vm.title)?_c('h4',{class:[
      'text-grey-10 text-weight-medium print-hide',
      {
        'q-py-md': _vm.$q.screen.xs,
        'q-py-lg': !_vm.$q.screen.xs
      }
    ]},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }